import { render } from "./RepeatBlockComponent.vue?vue&type=template&id=be2e91f0&scoped=true"
import script from "./RepeatBlockComponent.vue?vue&type=script&lang=js"
export * from "./RepeatBlockComponent.vue?vue&type=script&lang=js"

import "./RepeatBlockComponent.vue?vue&type=style&index=0&id=be2e91f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be2e91f0"

export default script